import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router';
import './App.css';
import LayoutProvider, { LayoutContext } from './context';
import { useContext, useEffect } from 'react';
import { CssBaseline, CssVarsProvider, extendTheme } from '@mui/joy';
import { AnimatePresence, motion } from 'framer-motion';

import MainPage from './pages/MainPage';
import Layout from './pages/Layout';
import MessagesPage from './pages/MessagesPage';
import UsersPage from './pages/UsersPage';
import ModalUser from './components/modals/ModalUser';
import SettingsPage from './pages/SettingsPage';
import TestResultsPage from './pages/TestingPages/TestResultsPage';
import TestsListPage from './pages/TestingPages/TestsListPage';
import TestCreateEditPage from './pages/TestingPages/TestCreateEditPage';
import TestResultModal from './components/modals/TestResultModal';
import ClientRequestsPage from './pages/ClientRequestsPage';
import ModalAssignTest from './components/modals/ModalAssignTest';
import TestAssignmentsPage from './pages/TestingPages/TestAssignmentsPage';
import ChatStatsPage from './pages/ChatStatsPage';
import AppointmentsPage from './pages/AppointmentsPage';
import BlockedProfilesPage from './pages/BlockedProfilesPage';
import LoginDoctorPage from './pages/LoginDoctorPage';
import LoginPatientPage from './pages/LoginPatientPage';
import RegisterPatientPage from './pages/RegisterPatientPage';
import PatientCabinetPage from './pages/PatientCabinetPage';
import SessionsPage from './pages/SessionsPage';
import RequireAuth from './components/RequireAuth';
import ConnectDoctorPage from './pages/ConnectDoctorPage';


const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return children;
};



const theme = extendTheme({
    colorSchemes: {
      light: {
        palette: {
          // primary: {
          //   50: '#e3f4ff',
          //   100: '#d1edff', // Цвет если soft вариант
          //   200: '#b8e3ff', // Цвет при наведении на кнопку если soft вариант
          //   300: '#2a95db', // Цвет бортиков если вариант outlined
          //   400: '#2178DD', // -
          //   500: '#009DFF', // Цвет фона для всех вариантов
          //   600: '#008ce3', // Цвет фона при наведении если solid вариант
          //   700: '#007ecc', // Цвет фона для всех вариантов (при нажатии)
          //   800: '#2F4968', // -
          //   900: '#2F3C4C', // -
          // },
          // primary: {
          //   50: '#fdf2f8',
          //   100: '#fce7f3',
          //   200: '#fbcfe8',
          //   300: '#f9a8d4',
          //   400: '#f472b6',
          //   500: '#ec4899', // Основной розовый цвет сакуры
          //   600: '#db2777',
          //   700: '#be185d',
          //   800: '#9d174d',
          //   900: '#831843',
          // },
          // primary: {
          //   50: '#f0f9f0',
          //   100: '#dcf0dc',
          //   200: '#b8e1b8',
          //   300: '#8fd18f',
          //   400: '#63c163',
          //   500: '#1E6E35', // Основной зеленый цвет
          //   600: '#1a6230',
          //   700: '#155529',
          //   800: '#114823',
          //   900: '#0d3b1c',
          // },
          primary: {
            50: '#eeedf6',
            100: '#d5d3ea',
            200: '#aba7d5',
            300: '#807bc0',
            400: '#5f5aab',
            500: '#403D84', // Основной цвет
            600: '#393677',
            700: '#302e64',
            800: '#272551',
            900: '#1e1c3e',
          },
          danger: {
            50: "#fde3e4",
            100: "#facccd",
            200: "#f49999",
            300: "#e0666b",
            400: "#cc3340",
            500: "#c30013",
            600: "#b10011",
            700: "#9e000e",
            800: "#8b000b",
            900: "#780008"
          },
          success: {
            50: "#F6FEF6",
            100: "#E3FBE3",
            200: "#C7F7C7",
            300: "#A1E8A1",
            400: "#51BC51",
            500: "#1F7A1F",
            600: "#136C13",
            700: "#0A470A",
            800: "#042F04",
            900: "#021D02"
          },
          neutral: {
            500: '#242424', // Цвет фона для всех вариантов
            600: '#2e2e2e', // Цвет фона при наведении если solid вариант
            700: '#1f1f1f', // Цвет фона для всех вариантов (при нажатии)
          },
        },
      },
      dark: {
        palette: {
          // primary: {
          //   50: '#e3f4ff',
          //   100: '#d1edff', // Цвет если soft вариант
          //   200: '#b8e3ff', // Цвет при наведении на кнопку если soft вариант
          //   300: '#2a95db', // Цвет бортиков если вариант outlined
          //   400: '#2178DD', // -
          //   500: '#009DFF', // Цвет фона для всех вариантов
          //   600: '#008ce3', // Цвет фона при наведении если solid вариант
          //   700: '#007ecc', // Цвет фона для всех вариантов (при нажатии)
          //   800: '#2F4968', // -
          //   900: '#2F3C4C', // -
          // },
          // primary: {
          //   50: '#fdf2f8',
          //   100: '#fce7f3',
          //   200: '#fbcfe8',
          //   300: '#f9a8d4',
          //   400: '#f472b6',
          //   500: '#ec4899', // Основной розовый цвет сакуры
          //   600: '#db2777',
          //   700: '#be185d',
          //   800: '#9d174d',
          //   900: '#831843',
          // },
          // primary: {
          //   50: '#f0f9f0',
          //   100: '#dcf0dc',
          //   200: '#b8e1b8',
          //   300: '#8fd18f',
          //   400: '#63c163',
          //   500: '#1E6E35', // Основной зеленый цвет
          //   600: '#1a6230',
          //   700: '#155529',
          //   800: '#114823',
          //   900: '#0d3b1c',
          // },
          primary: {
            50: '#eeedf6',
            100: '#d5d3ea',
            200: '#aba7d5',
            300: '#807bc0',
            400: '#5f5aab',
            500: '#403D84', // Основной цвет
            600: '#393677',
            700: '#302e64',
            800: '#272551',
            900: '#1e1c3e',
          },
          danger: {
            50: "#fde3e4",
            100: "#facccd",
            200: "#f49999",
            300: "#e0666b",
            400: "#cc3340",
            500: "#c30013",
            600: "#b10011",
            700: "#9e000e",
            800: "#8b000b",
            900: "#780008"
          },
          success: {
            50: "#F6FEF6",
            100: "#E3FBE3",
            200: "#C7F7C7",
            300: "#A1E8A1",
            400: "#51BC51",
            500: "#1F7A1F",
            600: "#136C13",
            700: "#0A470A",
            800: "#042F04",
            900: "#021D02"
          },
          neutral: {
            500: '#242424', // Цвет фона для всех вариантов
            600: '#2e2e2e', // Цвет фона при наведении если solid вариант
            700: '#1f1f1f', // Цвет фона для всех вариантов (при нажатии)
          },
        },
      }
    },
    // fontSize: {
    //   xl5: "5.25rem"
    // },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        sm2: 800,
        md: 900,
        md2: 1000,
        lg: 1200,
        xl: 1536,
        
        extrasmall: 300,
        small: 500,
        medium: 800,
        large: 1100,
      },
    },
    fontFamily: {
      body: 'FiraSansRegular',
      display: 'FiraSansMedium',
      fallback: 'Nunito'
    },
    components: {
      JoyButton: {
        styleOverrides: {
          root: ({ theme }) => ({
            transition: '.2s',
            borderRadius: theme.vars.radius.lg
          })
        }
      },
      JoyTextarea: {
        styleOverrides: {
          root: ({ theme }) => ({
            borderRadius: theme.vars.radius.lg
          })
        }
      },
      JoyInput: {
        styleOverrides: {
          root: ({ theme }) => ({
            borderRadius: theme.vars.radius.lg
          })
        }
      },
      JoySelect: {
        styleOverrides: {
          root: ({ theme }) => ({
            borderRadius: theme.vars.radius.lg
          })
        }
      },
      JoyAutocomplete: {
        styleOverrides: {
          root: ({ theme }) => ({
            borderRadius: theme.vars.radius.lg
          })
        }
      },
      JoyIconButton: {
        styleOverrides: {
          root: ({ theme }) => ({
            borderRadius: theme.vars.radius.lg
          })
        }
      }
    },
});



function AnimatePage() {
  const location = useLocation();

  return (
    <CssVarsProvider
      theme={theme}
      defaultMode="light"
    >
      <CssBaseline />
      <AnimatePresence>
        <Routes location={location} key={location.pathname}>
          {/* Публичные маршруты (без авторизации) */}
          <Route path="/login/doctor" element={<LoginDoctorPage />} />
          <Route path="/login/patient" element={<LoginPatientPage />} />
          <Route path="/register/patient" element={<RegisterPatientPage />} />
          <Route path="/connect" element={<ConnectDoctorPage />} />

          {/* Кабинет пациента и управление сеансами */}
          <Route path="/cabinet" element={<RequireAuth role="patient"><PatientCabinetPage /></RequireAuth>} />
          <Route path="/sessions" element={<RequireAuth role="any"><SessionsPage /></RequireAuth>} />

          <Route path='/' element={
            <RequireAuth role="any">
              <Layout/>
            </RequireAuth>
          }>
            <Route path="" element={<MainPage />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/chats" element={<MessagesPage />} />
            <Route path="/chat-stats" element={<ChatStatsPage />} />
            <Route path="/appointments" element={<AppointmentsPage />} />
            <Route path="/blocked-profiles" element={<BlockedProfilesPage />} />
            <Route path="/client-requests" element={<ClientRequestsPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            
            <Route path="/tests">
              <Route path="/tests/results" element={<TestResultsPage />} />
              <Route path="/tests/list" element={<TestsListPage />} />
              <Route path="/tests/test-assignments" element={<TestAssignmentsPage />} />

              <Route path="/tests/create" element={<TestCreateEditPage />} />
              <Route path="/tests/:testId/edit" element={<TestCreateEditPage />} />
            </Route>
          </Route>

        </Routes>
      </AnimatePresence>

      <ModalUser />
      <TestResultModal/>
      <ModalAssignTest/>
    </CssVarsProvider>
  );
}


function App() {
  return (
    <BrowserRouter>
      <LayoutProvider>
        <AnimatePage/>
      </LayoutProvider>
    </BrowserRouter>
  );
}

export default App;